export default __webpack_public_path__ + "static/media/family-day-bg-home.163a17c4.png";